import { getComponentsFromMap } from '../utils'

import WDataChart from './data/chart/WDataChart.vue'
import WDataSearchForm from './data/search/WDataSearchForm.vue'

import WAppBoard from './app/board/WAppBoard.vue'

const widgets: any[] = getComponentsFromMap({ WDataChart, WDataSearchForm, WAppBoard })

export { widgets }
